export default __webpack_public_path__ + "static/media/MERN-logo.39d4f786.png";